import Swal from "sweetalert2";
import { t } from "i18next";
import { const_routes } from "../helpers/const_routes";
import { fetchToken } from "../helpers/fetch";
import { types } from "../types/types";
import { startLogout } from "./authActions";
import { debugLogActions, debugErrorActions } from "../helpers/debugHelper";

const FLOW_CATALOG_TYPES = {
  states: "FLOW_STATE",
  pendingReasons: "FLOW_PENDING_REASON",
  cancelReasons: "FLOW_CANCEL_REASON",
  normalReasons: "FLOW_NORMAL_REASON",
  assignmentStrategies: "FLOW_ASSIGNMENT_STRATEGY",
  eventTypes: "FLOW_EVENT_TYPE",
  ownerApprovals: "FLOW_OWNER_APPROVAL"
};

const flowEngineSetLoading = (isLoading) => ({
  type: types.FLOWENGINE_SET_LOADING,
  payload: isLoading
});

const flowEngineSetCatalogs = (catalogs) => ({
  type: types.FLOWENGINE_SET_CATALOGS,
  payload: catalogs
});

const flowEngineSetInboxLoading = (isLoading) => ({
  type: types.FLOWENGINE_SET_INBOX_LOADING,
  payload: isLoading
});

const flowEngineSetInbox = (payload) => ({
  type: types.FLOWENGINE_SET_INBOX,
  payload
});

const handleCatalogError = (body, dispatch) => {
  if (body.code === "bak-error-001") {
    Swal.fire(t("titles.error"), `${t("alerts.validation.bak-error-001")} - ${body.method}`, "error");
  }
  if (body.code === "bak-aut-tok-inv-001") {
    Swal.fire(t("titles.error"), t("api.token.invalid_petition"), "error");
    dispatch(startLogout());
  }
  if (body.code === "bak-aut-tok-inv-002") {
    Swal.fire(t("titles.error"), t("alerts.validation.bak-aut-tok-inv-002"), "error");
    dispatch(startLogout());
  }
};

export const startLoadingFlowEngineCatalogs = () => {
  return async (dispatch, getState) => {
    const { flowEngine } = getState();
    if (flowEngine?.loading || (flowEngine?.loaded && Array.isArray(flowEngine?.ownerApprovals))) {
      return;
    }

    dispatch(flowEngineSetLoading(true));

    try {
      const requests = Object.entries(FLOW_CATALOG_TYPES).map(
        async ([key, typeName]) => {
          const resp = await fetchToken(
            `${const_routes.SCHEMA}`,
            `${const_routes.VERSIONV1}`,
            `${const_routes.ROUTE_CATALOG}`,
            `getByCatalogTypeName/${typeName}`
          );
          const body = await resp.json();

          debugLogActions(":: flowEngineActions, startLoadingFlowEngineCatalogs", { key, body });

          if (body.ok) {
            return { key, data: body.catalogs || [] };
          }

          handleCatalogError(body, dispatch);
          return { key, data: [] };
        }
      );

      const catalogsArray = await Promise.all(requests);
      const catalogs = catalogsArray.reduce(
        (acc, { key, data }) => ({
          ...acc,
          [key]: data
        }),
        {}
      );

      dispatch(flowEngineSetCatalogs(catalogs));
    } catch (error) {
      debugErrorActions(":: flowEngineActions, startLoadingFlowEngineCatalogs", { error });
      Swal.fire(t("titles.error"), t("alerts.validation.bak-error-001"), "error");
    } finally {
      dispatch(flowEngineSetLoading(false));
    }
  };
};

const buildInboxQueryString = (filters = {}) => {
  const params = new URLSearchParams();
  console.log("1111, JT, buildInboxQueryString, filters", filters);
  if (filters && filters.state_catalog_id) {
    console.log("1111, JT, buildInboxQueryString, filters.state_catalog_id", filters.state_catalog_id);
    params.append("state_catalog_id", filters.state_catalog_id);
  }
  if (filters && filters.pendingOnly) {
    console.log("1111, JT, buildInboxQueryString, filters.pendingOnly", filters.pendingOnly);
    params.append("pendingOnly", "true");
  }
  if (filters && filters.cancelOnly) {
    console.log("1111, JT, buildInboxQueryString, filters.cancelOnly", filters.cancelOnly);
    params.append("cancelOnly", "true");
  }
  const qs = params.toString();
  //return params.toString();
  return qs ? `?${qs}` : "";
};

export const startLoadingFlowInbox = ({
  moduleName,
  role,
  page = 0,
  size = 10,
  filters = {}
}) => {
  return async (dispatch) => {
    if (!moduleName || !role) {
      return;
    }

    dispatch(flowEngineSetInboxLoading(true));

    try {
      const queryString = buildInboxQueryString(filters);
      console.log("1111, JT, flowEngineActions, startLoadingFlowInbox, queryString", queryString);

      const endpoint = queryString
        ? `inbox/${role}/${page}/${size}?${queryString}`
        : `inbox/${role}/${page}/${size}`;

      //const endpoint3 = `${moduleName}/inbox/${role}/${page}/${size}`;

        console.log("1111, JT, flowEngineActions, startLoadingFlowInbox, endpoint", endpoint);

        /*
      const resp = await fetchToken(
        `${const_routes.SCHEMA}`,
        `${const_routes.VERSIONV1}`,
        endpoint3
      );*/


      const resp = await fetchToken(
      `${const_routes.SCHEMA}`,
      `${const_routes.VERSIONV1}`,
      `${moduleName}`,
      endpoint,
    );

      const body = await resp.json();
      debugLogActions(":: flowEngineActions, startLoadingFlowInbox", { endpoint, body });

      if (body.ok) {
        const inboxPayload = body.inbox || {};
        const rows = inboxPayload.rows || inboxPayload.records || [];
        dispatch(
          flowEngineSetInbox({
            moduleName,
            role,
            rows,
            totalItems: inboxPayload.totalItems ?? inboxPayload.total ?? rows.length,
            totalPages: inboxPayload.totalPages ?? inboxPayload.pages ?? 0,
            currentPage: inboxPayload.currentPage ?? inboxPayload.page ?? 0,
            filters
          })
        );
      } else {
        handleCatalogError(body, dispatch);
      }
    } catch (error) {
      debugErrorActions(":: flowEngineActions, startLoadingFlowInbox, error", { error, moduleName, role });
      Swal.fire(t("titles.error"), t("alerts.validation.bak-error-001"), "error");
    } finally {
      dispatch(flowEngineSetInboxLoading(false));
    }
  };
};

export const startLoadingFlowInboxByUser = ({
  moduleName,
  role,
  page = 0,
  size = 10,
  filters = {},
  userId
}) => {
  return async (dispatch) => {
    if (!moduleName || !role || !userId) {
      return;
    }

    dispatch(flowEngineSetInboxLoading(true));

    try {
      const queryString = buildInboxQueryString(filters);
      console.log("1111, JT, flowEngineActions, startLoadingFlowInboxByUser, queryString", queryString);

      const endpoint = queryString
        ? `inbox/${role}/${page}/${size}/${userId}?${queryString}`
        : `inbox/${role}/${page}/${size}/${userId}`;

      //const endpoint3 = `${moduleName}/inbox/${role}/${page}/${size}`;

        console.log("1111, JT, flowEngineActions, startLoadingFlowInboxByUser, endpoint", endpoint);

        /*
      const resp = await fetchToken(
        `${const_routes.SCHEMA}`,
        `${const_routes.VERSIONV1}`,
        endpoint3
      );*/

      const resp = await fetchToken(
      `${const_routes.SCHEMA}`,
      `${const_routes.VERSIONV1}`,
      `${moduleName}`,
      //`inbox/${role}/${page}/${size}`,
      endpoint,
    );

      const body = await resp.json();
      debugLogActions(":: flowEngineActions, startLoadingFlowInboxByUser", { endpoint, body });

      if (body.ok) {
        const inboxPayload = body.inbox || {};
        const rows = inboxPayload.rows || inboxPayload.records || [];
        dispatch(
          flowEngineSetInbox({
            moduleName,
            role,
            rows,
            totalItems: inboxPayload.totalItems ?? inboxPayload.total ?? rows.length,
            totalPages: inboxPayload.totalPages ?? inboxPayload.pages ?? 0,
            currentPage: inboxPayload.currentPage ?? inboxPayload.page ?? 0,
            filters
          })
        );
      } else {
        handleCatalogError(body, dispatch);
      }
    } catch (error) {
      debugErrorActions(":: flowEngineActions, startLoadingFlowInboxByUser, error", { error, moduleName, role });
      Swal.fire(t("titles.error"), t("alerts.validation.bak-error-001"), "error");
    } finally {
      dispatch(flowEngineSetInboxLoading(false));
    }
  };
};

export const startSearchingFlowInbox = ({
  moduleName,
  role,
  searchText = "",
  page = 0,
  size = 10,
  filters = {}
}) => {
  return async (dispatch) => {
    if (!moduleName || !role) {
      return;
    }

    dispatch(flowEngineSetInboxLoading(true));

    try {
      const queryString = buildInboxQueryString(filters);
      const endpoint = queryString
        ? `${moduleName}/inbox/${role}/search/${page}/${size}?${queryString}`
        : `${moduleName}/inbox/${role}/search/${page}/${size}`;

      const resp = await fetchToken(
        `${const_routes.SCHEMA}`,
        `${const_routes.VERSIONV1}`,
        endpoint,
        { searchText },
        "POST"
      );

      const body = await resp.json();
      debugLogActions(":: flowEngineActions, startSearchingFlowInbox", { endpoint, body });

      if (body.ok) {
        const inboxPayload = body.inbox || {};
        const rows = inboxPayload.rows || inboxPayload.records || [];
        dispatch(
          flowEngineSetInbox({
            moduleName,
            role,
            rows,
            totalItems: inboxPayload.totalItems ?? inboxPayload.total ?? rows.length,
            totalPages: inboxPayload.totalPages ?? inboxPayload.pages ?? 0,
            currentPage: inboxPayload.currentPage ?? inboxPayload.page ?? 0,
            filters
          })
        );
      } else {
        handleCatalogError(body, dispatch);
      }
    } catch (error) {
      debugErrorActions(":: flowEngineActions, startSearchingFlowInbox", { error, moduleName, role });
      Swal.fire(t("titles.error"), t("alerts.validation.bak-error-001"), "error");
    } finally {
      dispatch(flowEngineSetInboxLoading(false));
    }
  };
};




